const getters = {
    getSapaan: (state) => state.sapaan,
    getAgama: (state) => state.agama,
    getJenisKelamin: (state) => state.jenisKelamin,
    getKaryawanAll: (state) => state.karyawanAll,
    getKonsumen: (state) => state.konsumen,
    getKonsumenTiny: (state) => state.konsumenTiny,
    getTahapan: (state) => state.tahapan,
    getMesinAll: (state) => state.mesinAll,
    getAkunKeuangan: (state) => state.akunKeuangan,
    getAkunDebit: (state) => state.akunDebit,
    getWorkshop: (state) => state.workshop,
    getAkunKeuanganGlobal: (state) => state.akunKeuanganGlobal,
    getFinancialAccountFund: (state) => state.financialAccountFund,
    getListAssetsAccount: (state) => state.listAssetsAccount,
    getListKeuanganKasOutlet: (state) => state.listKeuanganKasOutlet,
    getListKeuanganKasWorkshop: (state) => state.listKeuanganKasWorkshop,
    getListKeuanganBiaya: (state) => state.listKeuanganBiaya,
    getListKeuanganOwner: (state) => state.listKeuanganOwner,
    getListBiayaItemKategori: (state) => state.listBiayaItemKategori,
    getDataMCoin: (state) => state.dataMCoin,
    shortcode: (state) => state.shortcode,
    getAkunEDC: (state) => state.akunEDC,
    getWhiteLabelStatus: (state) => state.whitelabelSetting.idowner ? true : false,
}

export default getters